var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWalkIn = function SvgWalkIn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 108 108",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".walk_in{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hospital"
  }, /*#__PURE__*/React.createElement("path", {
    className: "walk_in",
    d: "M73.7,84.06h-38a1.5,1.5,0,0,1-1.5-1.5V37.75a1.5,1.5,0,0,1,1.5-1.5h38a1.5,1.5,0,0,1,1.5,1.5V82.56A1.5,1.5,0,0,1,73.7,84.06Zm-36.52-3h35V39.25h-35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "walk_in",
    d: "M61.54,39.25H47.83a1.5,1.5,0,0,1-1.5-1.5V25.43a1.5,1.5,0,0,1,1.5-1.5H61.54a1.5,1.5,0,0,1,1.5,1.5V37.75A1.5,1.5,0,0,1,61.54,39.25Zm-12.21-3H60V26.93H49.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "walk_in",
    d: "M54.69,35.43a1.5,1.5,0,0,1-1.5-1.5V29.24a1.5,1.5,0,1,1,3,0v4.69A1.5,1.5,0,0,1,54.69,35.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "walk_in",
    d: "M57,33.09H52.34a1.5,1.5,0,1,1,0-3H57a1.5,1.5,0,1,1,0,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "walk_in",
    d: "M50.08,52.56H43.92a1.5,1.5,0,0,1-1.5-1.5V46.44a1.5,1.5,0,0,1,1.5-1.5h6.16a1.5,1.5,0,0,1,1.5,1.5v4.62A1.5,1.5,0,0,1,50.08,52.56Zm-4.66-3h3.16V47.94H45.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "walk_in",
    d: "M64.12,52.56H58a1.5,1.5,0,0,1-1.5-1.5V46.44a1.5,1.5,0,0,1,1.5-1.5h6.16a1.5,1.5,0,0,1,1.5,1.5v4.62A1.5,1.5,0,0,1,64.12,52.56Zm-4.66-3h3.16V47.94H59.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "walk_in",
    d: "M50.08,64.22H43.92a1.5,1.5,0,0,1-1.5-1.5V58.1a1.5,1.5,0,0,1,1.5-1.5h6.16a1.5,1.5,0,0,1,1.5,1.5v4.62A1.5,1.5,0,0,1,50.08,64.22Zm-4.66-3h3.16V59.6H45.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "walk_in",
    d: "M64.12,64.22H58a1.5,1.5,0,0,1-1.5-1.5V58.1A1.5,1.5,0,0,1,58,56.6h6.16a1.5,1.5,0,0,1,1.5,1.5v4.62A1.5,1.5,0,0,1,64.12,64.22Zm-4.66-3h3.16V59.6H59.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "walk_in",
    d: "M54.69,84.06a1.5,1.5,0,0,1-1.5-1.5V71a1.5,1.5,0,0,1,3,0V82.56A1.5,1.5,0,0,1,54.69,84.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "walk_in",
    d: "M61.54,84.06H47.83a1.5,1.5,0,0,1-1.5-1.5V71a1.5,1.5,0,0,1,1.5-1.5H61.54A1.5,1.5,0,0,1,63,71V82.56A1.5,1.5,0,0,1,61.54,84.06Zm-12.21-3H60V72.45H49.33Z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWalkIn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/walk_in.1d4e1c66.svg";
export { ForwardRef as ReactComponent };